import { render } from "./leftSideBarConfig.vue?vue&type=template&id=50a1ec52&scoped=true"
import script from "./leftSideBarConfig.vue?vue&type=script&lang=js"
export * from "./leftSideBarConfig.vue?vue&type=script&lang=js"

import "./leftSideBarConfig.vue?vue&type=style&index=0&id=50a1ec52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a1ec52"]])

export default __exports__